export default "__VITE_ASSET__54Qo8KVe__"